import { useTranslation } from "react-i18next";
import { setLanguage } from "@/lib/i18n";

const LANGS = [
  { code: "en", iso: "us", label: "English" },
  { code: "pt", iso: "br", label: "Português (Brasil)" },
];

export function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").startsWith("pt") ? "pt" : "en";
  return (
    <div data-testid="language-toggle" className={`inline-flex items-center gap-1.5 ${className}`}>
      {LANGS.map(({ code, iso, label }) => {
        const active = current === code;
        return (
          <button
            key={code}
            data-testid={`lang-${code}`}
            onClick={() => setLanguage(code)}
            title={label}
            aria-label={label}
            aria-pressed={active}
            className={`overflow-hidden rounded-md border transition-all duration-200 ${
              active
                ? "border-blue-600 ring-2 ring-blue-500/30 opacity-100 scale-105"
                : "border-slate-200 opacity-50 hover:opacity-90"
            }`}
          >
            <img
              src={`https://flagcdn.com/w40/${iso}.png`}
              srcSet={`https://flagcdn.com/w80/${iso}.png 2x`}
              alt={label}
              width={26}
              height={18}
              className="block w-[26px] h-[18px] object-cover"
            />
          </button>
        );
      })}
    </div>
  );
}
